<div class="navigation">
  <div class="cards">
    @if (pet$ | async; as pet) {
      @if (collar$ | async; as collar) {
        <app-collar-card [collar]="collar"></app-collar-card>
        <app-subscription-card [pet]="pet"></app-subscription-card>
        <app-activity-card [collar]="collar"
        [pet]="pet"></app-activity-card>
        <app-settings-card [collar]="collar"
        [pet]="pet"></app-settings-card>
      }
    }
  </div>

  <div class="modes">
    <mat-button-toggle-group [formControl]="mode">
      @for (mode of modes; track mode) {
        <mat-button-toggle
        [value]="mode.key">{{mode.label}}</mat-button-toggle>
      }
    </mat-button-toggle-group>

    <!--    <button mat-button-->
    <!--            color="accent"-->
    <!--            matTooltip="Send test push"-->
    <!--            (click)="sendPush()">-->
    <!--      <mat-icon>notifications_active</mat-icon>-->
  <!--    </button>-->

  @for (template of toolbar.items; track template) {
    <ng-container *ngTemplateOutlet="template"></ng-container>
  }
</div>

<div class="map">
  <ngrx-busy>
    <div id="map"></div>
  </ngrx-busy>

  <div class="walkers">
    @for (walker of walkers$ | async; track walker) {
      <img
        [src]="(walker.avatar || '/assets/images/profile.jpg') + '?size=small&scale=2'"
        [matTooltip]="walker.full_name"
        onerror="this.src='/assets/images/profile.jpg';"
        class="walker"/>
    }
  </div>
</div>

@if (pet$ | async; as pet) {
  <app-tracks
    [pet]="pet"
  class="tracks"></app-tracks>
}
</div>

<router-outlet #outlet="outlet"></router-outlet>

@if (collar$ | async; as collar) {
  <app-requests
    [device]="collar"
  class="requests"></app-requests>
}

<ng-template #petMarker
  let-pet="pet"
  let-color="color">
  <div>
    <img [src]="pet.avatar || '/assets/images/pet.png'"
         [ngStyle]="{
         'position': 'absolute',
         'z-index': 5,
         'height.px': 56,
         'width.px': 56,
         'border-radius.%': 50,
         'border': 'solid 3px ' + color,
         'background': color,
         'object-fit': 'cover'
         }" />
    <i [ngStyle]="{
      'display': 'block',
      'position': 'absolute',
      'bottom.px': 2,
      'left.px': 21,
      'height.px': 20,
      'width.px': 20,
      'border-radius.px': 3,
      'transform': 'rotate(-45deg)',
      '-webkit-transform': 'rotate(-45deg)',
      'background': color
      }"></i>
  </div>
</ng-template>
